import { Navigate } from "react-router-dom";

export default function ProviderEarnings() {
  return <Navigate to="/revenue-center?view=venue" replace />;
}
